/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

type Props = {
    id?: string;
};

const BasicBlocks: React.FC<Props> = (props): JSX.Element => {
    const [buttonText] = useState("Copy Code");

    const handleCopyClick = async (codeId: string) => {
        const codeElement = document.getElementById(codeId);
        const buttonElement = document.getElementById(`copyButton_${codeId}`);

        if (codeElement && buttonElement) {
            const codeText = codeElement.innerText;
            try {
                await navigator.clipboard.writeText(codeText);
                buttonElement.innerText = "Copied!";
                setTimeout(() => {
                    buttonElement.innerText = "Copy Code";
                }, 2000);
            } catch (err) {
                console.error("Unable to copy to clipboard", err);
            }
        }
    };

    return (
        <section className="container flex flex-col">
            <div className="flex flex-col my-2 space-y-2">
                <div className="flex flex-col w-full">
                    <h2 className="text-lg py-2 text font-semibold">
                        Hero Section
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>

                        <TabsContent value="example" className="p-8 w-10/12">
                            <img src="https://hncnzwww.blob.core.windows.net/www/img/design-elemets_examples/home_section_1.png" alt="heroImage" />
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex items-end w-full justify-end px-6">
                                <button
                                    id="copyButton_code_hero"
                                    onClick={() => handleCopyClick("code_hero")}
                                    className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                                >
                                    {buttonText}
                                </button>
                            </div>
                            <div className="flex flex-col items-center px-6 whitespace-pre-line">
                                <code id="code_hero" className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                    <section className="w-full bg-black">
                                        <div className="relative flex flex-col w-full h-[90vh] md:h-[50vh] xl:h-screen">
                                            <video
                                                className="absolute inset-0 w-full h-full object-cover"
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                src="https://hncnzwww.blob.core.windows.net/www/videos/hnc_commercial_video.mp4"
                                            />
                                            <div className="relative flex flex-col items-center justify-center h-full text-center text-white px-4 z-10">
                                                <h1 className="mb-6 font-bold tracking-tight text-white sm:text-4xl sm:leading-none">
                                                    Complete Commercial Solutions
                                                </h1>
                                                <p className="mb-6 text-base text-white md:text-lg md:px-24">
                                                    Discover a world of possibilities with Harvey Norman Commercial
                                                </p>
                                                <div className="flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                                                    <a href="#" className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-harvey-red hover:bg-harvey-red/80 focus:shadow-outline focus:outline-none">
                                                        Get Quote
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="absolute inset-0 bg-black opacity-60"></div>
                                        </div>
                                    </section>
                                    `}
                                </code>
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>

                <div className="flex flex-col w-full">
                    <h2 className="text-lg py-2 text font-semibold">
                        2 Column Grid Section
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>

                        <TabsContent value="example" className="p-8 w-10/12">
                            <img src="https://hncnzwww.blob.core.windows.net/www/img/design-elemets_examples/2_column_grid.png" alt="heroImage" />
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex items-end w-full justify-end px-6">
                                <button
                                    id="copyButton_code_grid"
                                    onClick={() => handleCopyClick("code_grid")}
                                    className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                                >
                                    {buttonText}
                                </button>
                            </div>
                            <div className="flex flex-col items-center px-6 whitespace-pre-line">
                                <code id="code_grid" className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                    <section className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                                        <div className="grid gap-10 lg:grid-cols-2">
                                            <div className="flex flex-col justify-center md:pr-8 xl:pr-0 lg:max-w-lg">
                                                <div className="max-w-xl mb-6">
                                                    <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
                                                        Complete Commercial Solutions
                                                        <br className="hidden md:block" />
                                                        Your Business Partner
                                                    </h2>
                                                    <p className="text-base text-gray-700 md:text-lg">
                                                        We're here to help you succeed.
                                                    </p>
                                                </div>
                                                <div>
                                                    <a href="/" className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800">
                                                        Learn more
                                                        <svg className="inline-block w-3 ml-2" fill="currentColor" viewBox="0 0 12 12">
                                                            <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-center -mx-4 lg:pl-8">
                                                <div className="flex flex-col items-end px-3">
                                                    <img className="object-cover mb-6 rounded shadow-lg h-28 sm:h-48 xl:h-56 w-28 sm:w-48 xl:w-56"
                                                        src="https://hncnzwww.blob.core.windows.net/www/img/NewWebPhotos/Homepage/hnc-web-homepage-turn-key-solutions.jpg"
                                                        alt=""
                                                    />
                                                    <img className="object-cover w-20 h-20 rounded shadow-lg sm:h-32 xl:h-40 sm:w-32 xl:w-40"
                                                        src="https://hncnzwww.blob.core.windows.net/www/img/NewWebPhotos/Homepage/hnc_web_homepage_appliances.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="px-3">
                                                    <img className="object-cover w-40 h-40 rounded shadow-lg sm:h-64 xl:h-80 sm:w-64 xl:w-80"
                                                        src="https://hncnzwww.blob.core.windows.net/www/img/NewWebPhotos/Homepage/hnc-homepage-furniture-bedding.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    `}
                                </code>
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </section>
    );
};

export default BasicBlocks;
